export const NOTIFICATION_PERIOD = {
	GENERAL: "My Breed",
	HEALTH: "Health",
	EXERCISE: "Exercise",
	P6M: "6 months",
	P9M: "9 months",
	P12M: "12 months",
	P18M: "18 months",
	P24M: "24 months",
	P2Y: "2 years",
}

export const NOTIFICATION_TYPE = {
	GEN_INFO: "GEN_INFO",
	TREATMENT: "TREATMENT",
	TRACKING: "TRACKING",
	HEALTH_DATA: "HEALTH_DATA",
	REWARDS: "REWARDS",
	SUBS: "SUBS",
	ADM_NOTIF: "ADM_NOTIF",
	SOCIAL_GRP: "SOCIAL_GRP",
	CONTENT: "CONTENT",
	REMINDER: "REMINDER",
	PET_ORDER: "PET_ORDER",
	PRODUCT: "PRODUCT",
	CREDIT: "CREDIT",
	DOG_PURCHASE: "DOG_PURCHASE",
	PUPPY_SELL: "PUPPY_SELL",
	BREEDER: "BREEDER",
	LITTER_REMINDERS: "LITTER_REMINDERS"
}

export const NOTIFICATION_ICON = {
	GEN_INFO: "gen-info.png",
	TREATMENT: "treatment.png",
	TRACKING: "tracking.png",
	HEALTH_DATA: "health-data.png",
	REWARDS: "rewards.png",
	SUBS: "shop.png",
	ADM_NOTIF: "pet-details.png",
	SOCIAL_GRP: "social-club-icon.png",
	CONTENT: "social-club-icon.png",
	REMINDER: "gen-info.png",
	PET_ORDER: "dog-purchase.png",
	PRODUCT: "shop.png",
	CREDIT: "pet-details.png",
	DOG_PURCHASE: "dog-purchase.png",
	PUPPY_SELL: "dog-purchase.png",
	BREEDER: "pet-details.png",
	LITTER_REMINDERS: "pet-details.png"	
}

export const NOTIFICATION_URL = {
	GEN_INFO: "/dashboard",
	TREATMENT: "/treatment",
	TRACKING: "/tracking",
	HEALTH_DATA: "/health-data",
	REWARDS: "/rewards",
	SUBS: "/purchases/subscriptions",
	SOCIAL_GRP: "/social/group",
	CONTENT: "/post",
	REMINDER: "/dashboard",
	PRODUCT: "/purchases/orders",
}
